module.exports = __webpack_public_path__ + "static/media/agi.76ae3140.svg";